"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioContent;

function AudioContent() {
  return {
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBdWRpb0NvbnRlbnQiLCJ3aWR0aCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0eWxlcy9TdHlsZVNldC9BdWRpb0NvbnRlbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQXVkaW9Db250ZW50KCkge1xuICByZXR1cm4ge1xuICAgIHdpZHRoOiAnMTAwJSdcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLFlBQVQsR0FBd0I7RUFDckMsT0FBTztJQUNMQyxLQUFLLEVBQUU7RUFERixDQUFQO0FBR0QifQ==